<template>
  <PopUp
    :clickOutsideClose="false"
    :pop-up-active="popUpActive"
    :title="`SOS${$t('緊急求助')}`"
    @click="$_sosPopupClose()"
  >
    <LlCancelPopupContent v-if="!giveUpSos && !send">
      <ValidationObserver ref="formObserver">
        <InputListCard>
          <div class="input-item">
            <StateInputButton
              v-model="sosData.name"
              :title="$t('聯絡人姓名')"
              placeholder="輸入"
              rules="required"
              required
            />
          </div>
          <div class="multiple-input-item">
            <div
              class="input-item"
              style="min-width: 200px;"
            >
              <DropdownMenuButton
                v-model="sosContactWay.selectedMenuItem"
                :dropdown-menu-item="sosContactWay.menuItems"
                :placeholder="sosContactWay.placeholder"
                :title="$t('聯絡方式')"
                outline
                required
              />
            </div>
            <div
              class="input-item"
              style="width: 100%;"
            >
              <StateInputButton
                v-if="sosContactWay.selectedMenuItem === 'tel'"
                v-model="sosData.tel"
                :title="_sosContactWay"
                placeholder="0900-000-000"
                rules="required"
                required
              />
              <StateInputButton
                v-if="sosContactWay.selectedMenuItem === 'email'"
                v-model="sosData.email"
                :title="_sosContactWay"
                placeholder="aa@xxxxxx.com"
                rules="required|email"
                required
              />
            </div>
          </div>
          <div class="input-item">
            <LvStateRadioBtn
              v-model="sosContactFor.selected_condition"
              :title="$t('詢問主旨')"
              :radio-button-item="sosContactFor"
              row
              required
            />
          </div>
          <div class="input-item">
            <div class="input">
              <InputTextareaButton
                v-model="sosData.remark"
                :title="$t('簡述')"
                :min-height="134"
                :placeholder="`${$t('輸入')}`"
                required
                rules="required"
              >
                <template v-slot:button>
                  <UploadFileButton
                    v-model="sosData.attaches"
                    text
                    :factory="_currentFactoryId"
                    :text-label="$t('附件')"
                    upload-url="/sos_request/attach/"
                    multiple
                  />
                </template>
                <template
                  v-if="sosData.attaches.length > 0"
                  v-slot:attaches
                >
                  <div>
                    <LlFileList
                      :attaches="sosData.attaches"
                      outline
                      upload
                      two-item
                      narrow
                      showDeleteBtn
                      :margin-top="20"
                      @delete-file="$_deleteAttach($event)"
                    />
                  </div>
                </template>
              </InputTextareaButton>
            </div>
          </div>
        </InputListCard>
      </ValidationObserver>
      <template v-slot:buttons>
        <WsButton001
          width200
          out-line
          @click="$_sosGiveUp()"
        >
          {{ $t('取消') }}
        </WsButton001>
        <WsButton001 @click="$_sosSubmit()">
          {{ $t('送出') }}
        </WsButton001>
      </template>
    </LlCancelPopupContent>
    <LlCancelPopupContent
      v-if="giveUpSos && !send"
      :cancel-text="$t('確定捨棄嗎？')"
    >
      <template v-slot:buttons>
        <WsButton001
          outLine
          @click="$_sosContinue()"
        >
          {{ $t('取消') }}
        </WsButton001>
        <WsButton001
          @click="$_sosPopupClose()"
        >
          {{ $t('確定') }}
        </WsButton001>
      </template>
    </LlCancelPopupContent>
    <LlCancelPopupContent v-if="send">
      <LlSos v-if="send" />
    </LlCancelPopupContent>
  </PopUp>
</template>
<script>
import { ValidationObserver } from "vee-validate";
// import scope from "@/service/api/v1/scope";
import sosRequestService from "@/service/api/v1/sos_request";

export default {
  name: "SosPopup",
  components: {
    ValidationObserver,
  },
  props: {
    popUpActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popup: { invalidScopeActive: false, sosActive: false },
      giveUpSos: false,
      send: false,
      sosData: {
        name: "",
        email: "",
        tel: "",
        remark: "",
        attaches: [],
      },
      sosContactFor: {
        name: "sosContactFor",
        selected_condition: 1,
        buttonItems: [
          {
            id: 1,
            textLabel: this.$t("緊急法律協助"),
            value: "legalAssistance",
          },
          {
            id: 2,
            textLabel: this.$t("系統操作協助"),
            value: "operationTutorial",
          },
        ],
      },
      sosContactWay: {
        placeholder: "",
        selectedMenuItem: "email",
        menuItems: [
          {
            id: "tel",
            textLabel: this.$t("手機"),
          },
          {
            id: "email",
            textLabel: this.$t("信箱"),
          },
        ],
      },
    };
  },
  computed: {
    _currentScopes() {
      return this.$store.state.user.scopes;
    },
    _currentUser() {
      return this.$store.state.stone_auth.currentUser;
    },
    _currentFactoryId() {
      return this.$route.params.factoryId;
    },
    _currentOrganizationId() {
      return this.$route.params.organizationId;
    },
    _currentFactory() {
      return this.$store.state.app.factory;
    },
    _sosContactWay() {
      let contactWay = "";
      if (this.sosContactWay.selectedMenuItem === "tel") {
        contactWay = this.$t("手機號碼");
      } else if (this.sosContactWay.selectedMenuItem === "email") {
        contactWay = this.$t("信箱");
      }
      return contactWay;
    },
    _contactFor() {
      return this.$store.state.sospopup.contactFor;
    },
  },
  watch: {
    popUpActive() {
      if (this.popUpActive) {
        this.$_init();
      }
    },
  },
  methods: {
    $_init() {
      this.$_clearSosData();
      this.sosData.name = this._currentUser.name;
      this.giveUpSos = false;
      this.send = false;
      this.sosContactFor.selected_condition = this._contactFor;
    },
    $_sosPopupClose() {
      this.$store.dispatch("sospopup/closeSosPopup");
    },
    $_clearSosData() {
      this.sosData = {
        name: "",
        email: "",
        tel: "",
        remark: "",
        attaches: [],
      };
    },
    $_sosGiveUp() {
      let sosContent = false;
      for (let dataKey in this.sosData) {
        if (this.sosData[dataKey]) {
          sosContent = true;
        }
      }
      if (sosContent) {
        this.giveUpSos = true;
        return;
      }
      this.$_sosPopupClose();
    },
    $_sosContinue() {
      this.giveUpSos = false;
    },
    async $_sosSubmit() {
      const isValidate = await this.$refs.formObserver.validate();
      if (!isValidate) {
        return;
      }
      this.send = true;
      let contactFor = this.$_getContactWay(
        this.sosContactFor.selected_condition
      );
      let attaches = this.sosData.attaches.map((img) => img.url);
      let sosData = {
        contact_person: this.sosData.name,
        contact_way: this.sosContactWay.selectedMenuItem,
        contact_for: contactFor,
        tel: this.sosData.tel,
        email: this.sosData.email,
        remark: this.sosData.remark,
        attaches: attaches,
        user: this._currentUser.id,
        factory: this._currentFactory.id,
        user_payload: {
          id: this._currentUser.id,
          name: this._currentUser.name,
        },
      };
      if (this._currentOrganizationId) {
        await sosRequestService.create(
          this._currentFactoryId,
          sosData,
          "organization"
        );
      } else {
        await sosRequestService.create(this._currentFactoryId, sosData);
      }
    },
    $_getContactWay(wayId) {
      let allContactWay = this.sosContactFor.buttonItems.map((way) => way.id);
      let contactWaySelectNum = allContactWay.indexOf(wayId);
      return this.sosContactFor.buttonItems[contactWaySelectNum].value;
    },
    $_deleteAttach($event) {
      this.sosData.attaches.splice($event, 1);
    },
  },
};
</script>
